import { GetQueryString } from "@/utils/GetQueryString";

/**
 *  获取渠道号
 *  url上存在获取url中渠道 存储防止页面跳转丢失
 *  url上没有，获取缓存中的渠道
 *  返回默认渠道
 * @returns {any}
 */
export function getChannel() {
  const channel =
    GetQueryString("channel") ||
    window.localStorage.getItem("channel") ||
    "haima004";
  if (channel) {
    window.localStorage.setItem("channel", channel);
    return channel;
  }

  if (window.localStorage.getItem("channel")) {
    return window.localStorage.getItem("channel");
  }

  return "haima004";
}
